import * as Sentry from "@sentry/react";
import { getAuthHeader } from "ui";
import { fetchData } from "../libs/util.js";

// StripeProcessor5's billing routes answer 401 without a valid token and 403 when
// the login isn't the Stripe customer's owner (resolveOwnCustomer). Each route and
// status is its own Sentry issue, so a spike after a release can raise an alert.
export function reportBillingRefusal(route: string, error: unknown) {
  const status = (error as { status?: number })?.status;
  if (status !== 401 && status !== 403) return;
  Sentry.captureMessage(`Billing request refused: ${route} (${status})`, {
    level: "error",
    tags: { billing_refusal: route, http_status: String(status) },
    fingerprint: ["billing-refusal", route, String(status)],
    extra: { message: (error as Error)?.message },
  });
}

// fetchData with the signed-in user's token. Like fetchData, undefined on failure.
export async function fetchBilling(route: string, body: unknown, url: string) {
  try {
    return await fetchData(body, url, await getAuthHeader(), { rethrow: true });
  } catch (error) {
    reportBillingRefusal(route, error);
    return undefined;
  }
}
